import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

type HistoryRecord = {
  id: string;
  createdAt: string;
  input: any;
  result: any;
  limitsVersion?: string;
};

const HistoryPage: React.FC = () => {
  const [historyData, setHistoryData] = useState<HistoryRecord[]>(
    JSON.parse(localStorage.getItem('calculationHistory') || '[]')
  );

  const handleDelete = (id: string) => {
    const updatedHistory = historyData.filter((x) => x.id !== id);
    setHistoryData(updatedHistory);
    localStorage.setItem('calculationHistory', JSON.stringify(updatedHistory));
  };

  return (
    <TableContainer component={Paper}>
      <Typography variant="h6" component="div" gutterBottom>
        Calculation History
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell title="After tax">Total</TableCell>
            <TableCell title="After tax with Housing Fund">Savings</TableCell>
            <TableCell title="Average Monthly Savings">Average</TableCell>
            <TableCell>Limits</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {historyData.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{new Date(row.createdAt).toLocaleString()}</TableCell>
              <TableCell>{row.result.totalSalaryAfterTax.toFixed(2)}</TableCell>
              <TableCell>{row.result.totalSalaryWithHousingFund.toFixed(2)}</TableCell>
              <TableCell>{(row.result.totalSalaryWithHousingFund / 12).toFixed(2)}</TableCell>
              <TableCell>{row.limitsVersion ?? '-'}</TableCell>
              <TableCell>
                <IconButton onClick={() => handleDelete(row.id)} aria-label="delete">
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default HistoryPage;